// extracted by mini-css-extract-plugin
export var bar = "info-bars-module--bar--x0N1Q";
export var container = "info-bars-module--container--70Vog";